// Crochette — scripts propios. Vanilla JS, sin librerías externas.
(function () {
  function initReveals() {
    var els = document.querySelectorAll('.cro-reveal');
    if (!els.length) return;
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('cro-visible'); });
      return;
    }
    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('cro-visible');
          obs.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15, rootMargin: '0px 0px -60px 0px' });
    els.forEach(function (el) { obs.observe(el); });
  }

  function initTilt() {
    var cards = document.querySelectorAll('.cro-tilt');
    if (!cards.length || matchMedia('(hover: none)').matches) return;
    cards.forEach(function (card) {
      card.addEventListener('mousemove', function (e) {
        var r = card.getBoundingClientRect();
        var x = (e.clientX - r.left) / r.width - 0.5;
        var y = (e.clientY - r.top) / r.height - 0.5;
        card.style.transform = 'perspective(700px) rotateY(' + (x * 6) + 'deg) rotateX(' + (y * -6) + 'deg) translateY(-4px)';
      });
      card.addEventListener('mouseleave', function () {
        card.style.transform = '';
      });
    });
  }

  function initHeroParallax() {
    var heroes = document.querySelectorAll('[data-cro-parallax]');
    if (!heroes.length || matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var ticking = false;
    function update() {
      heroes.forEach(function (hero) {
        var rect = hero.getBoundingClientRect();
        var progress = Math.min(Math.max((0 - rect.top) / (rect.height || 1), -1), 1);
        var img = hero.querySelector('[data-cro-parallax-img]');
        if (img) img.style.transform = 'translateY(' + (progress * 26) + 'px) scale(1.06)';
      });
      ticking = false;
    }
    document.addEventListener('scroll', function () {
      if (!ticking) { requestAnimationFrame(update); ticking = true; }
    }, { passive: true });
    update();
  }

  document.addEventListener('DOMContentLoaded', function () {
    initReveals();
    initTilt();
    initHeroParallax();
  });
})();
